import React from 'react';
import { Link } from "react-router-dom";
import CharterImg from '../images/Yacht.png';

export const ChartersPageFirstSection = () => {
  // Updated sample data with different durations for each charter
  const chartersData = [
    { id: 1, price: 2000-2300, hours: 4 },
    { id: 2, price: 2700-3000, hours: 6 },
    { id: 3, price: 3200-3500, hours: 8 },
    
  ];

  // Divide the data into two arrays for two rows
  const firstRowData = chartersData.slice(0, 3);

  return (
    <div className="CharterBoxArae" id="Charter">
      <div className="container">
        {/* First Row */}
        <div className="row">
          {firstRowData.map((charter) => (
            <div key={charter.id} className="col-lg-4 slide-in-left">
              <div className="CharterBox">
                <img src={CharterImg} alt="Charter" />
                <div className="chartercontent">
                  <h2>Luxury Charters</h2>
                  <div className="bookingprice">
                    <p className="chartprice">$ {charter.price}</p>
                    <p className="bookinghrs">{charter.hours} Hours</p>
                  </div>
                  <Link to="/Booking">
                    <button>Book Now</button>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
        
      </div>
    </div>
  );
};
